import Title from "Components/Card/title";
import Table from "../MUI_components/Table/table";
import checkInService from "Service/CheckIn/checkIn.service";
import { COLUMNS_NAME } from "Components/Constants/ColumnsNames";
import { PinDrop } from "@mui/icons-material";
import { setDateTime } from "Helper/setDateTime";
import { DATE_FORMATS } from "Components/Constants/DateFormats";

const CheckInDashboard = () => {
  const headCells = [
    {
      id: (row) => row?.code,
      numeric: false,
      label: COLUMNS_NAME.CODE,
    },
    {
      id: (row) => row?.remarks,
      label: COLUMNS_NAME.DESCRIPTION,
    },
    {
      id: (row) => row?.processable?.code,
      label: `${COLUMNS_NAME.PROCESS} ${COLUMNS_NAME.CODE}`,
    },
    {
      id: (row) =>
        row?.processable?.firstName || row?.processable?.secondName
          ? `${row?.processable?.firstName} ${row?.processable?.secondName}`
          : "",
      label: `${COLUMNS_NAME.PROCESS} ${COLUMNS_NAME.VALUE}`,
    },
    {
      id: (row) => {
        return setDateTime(
          row?.checkInDateTime,
          DATE_FORMATS.TABLE_LAYOUT_FORMAT
        );
      },
      label: COLUMNS_NAME.CHECK_IN_DATE,
    },
    {
      id: (row) => {
        return setDateTime(
          row?.processable?.createdAt,
          DATE_FORMATS.TABLE_LAYOUT_FORMAT
        );
      },
      label: COLUMNS_NAME.COMPLETED + " " + COLUMNS_NAME.DATE,
    },
    {
      id: (row) => {
        return (
          <a
            href={`http://maps.google.com/?q=${row.latitude},${row.longitude}`}
            rel="noreferrer"
            target="_blank"
          >
            {<PinDrop />}
          </a>
        );
      },
      number: false,
      label: COLUMNS_NAME.LOCATION,
    },
  ];

  return (
    <>
      <Title>Check-in Dashboard</Title>
      <Table
        title={"Check-In"}
        headCells={headCells}
        service={checkInService}
        // searchable
        withoutLocationFilter
      />
    </>
  );
};

export default CheckInDashboard;
